import { ClientError } from 'graphql-request';

export const redactGraphqlRequestErrorForTelemetry = (error: unknown): unknown =>
  error instanceof ClientError
    ? new Error(error.response.errors?.length ? 'GraphQL request failed' : 'Network request failed')
    : error;
